// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDayz-iA9-xfbjokk82sEXu5wBNTIRawts",
  authDomain: "dhananjayportfolio-16274.firebaseapp.com",
  projectId: "dhananjayportfolio-16274",
  storageBucket: "dhananjayportfolio-16274.firebasestorage.app",
  messagingSenderId: "816863393010",
  appId: "1:816863393010:web:de0fd19739f56bd3a8cc6b",
  measurementId: "G-6QJQB2PFZH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };